import { FormInfobox } from "@/forms-design-system/FormInfobox/FormInfobox";
import { FormTextButton } from "@/forms-design-system/FormTextButton/FormTextButton";
import { FormTypography } from "@/forms-design-system/FormTypography/FormTypography";
import { Trans } from "@/common/hooks/useTranslate";
import { Ticket } from "@/icons/outlined";

import { useSweepstakesRulesContext } from "./Context/SweepstakesRulesContext";

export const SweepstakesNoDonationInfobox = () => {
  const { showHowToEnter } = useSweepstakesRulesContext();

  return (
    <FormInfobox
      icon={<Ticket />}
      components={{ icon: { size: "large" } }}
      description={
        <FormTypography variant="subtitle1">
          <Trans
            space="ticketing"
            i18nKey="sweepstakes.noDonationNecessary"
            components={{
              action: (
                // eslint-disable-next-line jsx-a11y/control-has-associated-label
                <FormTextButton
                  type="button"
                  onClick={showHowToEnter}
                  sx={{
                    color: "inherit",
                    display: "inline",
                    font: "inherit",
                    textDecoration: "underline",
                    verticalAlign: "baseline",
                  }}
                />
              ),
            }}
          />
        </FormTypography>
      }
      data-test="sweepstakes-no-donation-infobox"
    />
  );
};
